import { useMemo, useEffect } from 'react';
import { FormGroup, Select } from '@bigcommerce/big-design';
import {
	useCustomerGroup,
	useCurrency,
	useCustomerGroupAndProductTypes,
	useOrderProducts,
} from '../../../../../context';

export default function ClientType({ customer }) {
	const [, , customerGroups] = useCustomerGroupAndProductTypes();
	const [customerGroup, setCustomerGroup] = useCustomerGroup();
	const [, setCurrency] = useCurrency();
	const [products] = useOrderProducts();

	const options = useMemo(
		() =>
			customerGroups.map(({ id, name }) => ({
				value: id,
				content: name,
			})),
		[customerGroups],
	);

	useEffect(() => {
		const selectedGroupName = customerGroups.find(
			(group) => group.id === customerGroup,
		)?.name;
		setCurrency(selectedGroupName?.includes('CAN') ? 'CAD' : 'USD');
	}, [customerGroups, customerGroup]);

	if (customerGroups?.length <= 0) return null;

	return (
		<FormGroup>
			<Select
				filterable={true}
				options={options}
				label="Client Type"
				required
				value={customerGroup}
				disabled={
					customer.customer_group_id ||
					(customerGroup && products.length)
				}
				onOptionChange={setCustomerGroup}
			/>
		</FormGroup>
	);
}
